<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    errors?: string[]
  }>(),
  {}
)
</script>

<template>
  <Transition name="fade">
    <div v-if="props.errors?.length">
      <div class="error-text" v-bind:key="err" v-for="err in errors">
        {{ err }}
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.error-enter-active,
.error-leave-active {
  transition: opacity 100ms ease-in;
  opacity: 1;
}

.error-enter-from,
.error-leave-to {
  opacity: 0;
}
</style>
